<style scoped lang="scss">
@import "mobile";
.banner{
  img{
    width: 100%;
  }
}
.sample{
  padding:15px;
  .title{
    font-size: 15px;
    font-weight: bold;
    display: flex;
    align-items: center;
    margin:15px 0;
    &:before{
      content: '';
      display: block;
      width:5px;
      height:17px;
      background: #014492;
      margin-right: 10px;
    }
    small{
      font-weight: normal;
      font-size: 12px;
      color: #999;
    }
  }
  input{
    padding-bottom: 10px;
    width: 100%;
    border-bottom: 1px solid #F5F5F5;
  }
}
.popup-success{
  width:80vw;
  text-align: center;
  padding:30px 15px 0;
  .icon-sucess{
    width:60px;
  }
  .btn-confirm{
    border-top:1px solid #F5F5F5;
    color:#014492;
    margin-top: 20px;
    padding:15px 0;
    font-weight: bold;
  }
}
</style>
<template>
  <div class="wrap-app">
    <qk-back/>
    <div class="banner">
      <img src="@/assets/images/mobile/sunger_banner.png">
    </div>
    <div class="sample">
      <div class="title">备注</div>
      <input placeholder="填写测序备注信息" v-model="remark"/>
      <div class="title">我的地址<small>（若地址发生变动，请前往官网用户中心修改）</small></div>
      <p>{{curAddress}}</p>
    </div>
    <div class="btn-action">
      <button class="btn btn-sencond btn-block" @click="bindExample" v-preventReClick>发起取样</button>
    </div>
    <!--取样成功弹框-->
    <mt-popup
      :closeOnClickModal="false"
      v-model="successVisible">
      <div class="popup-success">
        <img src="@/assets/images/mobile/icon_success.png" class="icon-sucess">
        <p class="fz18 fb mt20">发起取样成功</p>
        <p class="mt10">我们的取样员正在赶来中~</p>
        <div class="btn-confirm" @click="closeModal">确定</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import { brindOrders } from '@/services/api.index'
export default {
  data () {
    return {
      successVisible: false,
      remark: '',
      curAddress: ''
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    // 获取用户信息
    async getUserInfo () {
      let userInfo
      if (this.baseMethods.getLocalObj('memberInfo')) {
        userInfo = this.baseMethods.getLocalObj('memberInfo')
      } else {
        userInfo = await this.$store.dispatch('memberInfo')
      }
      const address = userInfo.deliveryAddress
      this.curAddress = `${address.province}${address.city}${address.county ? address.county : ''}${address.detail}`
    },
    // 发起取样
    bindExample () {
      let address = this.baseMethods.getAddress()
      if (this.baseMethods.isEmpty(this.remark)) {
        return this.$toast('请填写测序备注信息')
      }
      brindOrders(this.remark, '', address).then(() => {
        this.successVisible = true
      })
    },
    closeModal () {
      this.successVisible = false
      this.$router.push('/mobile')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/sample.vue